<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
      font-weight: 400;
      color: #424242;">
        <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;
          My Pending Submission</h5>
      </div>
<div id="mainContent" class="container">
  <div class="row pt-2">
    <div class="col-md-4">
      <div class="form-group mb-0">
        <label class="mb-0">Financial Year :</label>
        <select class="form-control form-control-sm" [id]="'financialYear'" [name]="'financialYear'"
        type="text" [(ngModel)]="selectedFY" matTooltip="'select FY year'" matTooltipPosition="above"
        (change)="onloadWeeksForFY()">
        <option [value]="null">Select</option>
        <option *ngFor="let financialYear of financialYearList " [ngValue]="financialYear">{{ financialYear.name }}</option>
        </select>
      </div>
    </div>
    <div class="col-md-4"></div>

  </div>

<br>
<div>
  <div class="row">
    <div class="col-md-12">
      <table class="table table-bordered table-striped table-sm">
        <thead class="">
          <tr>
            <th scope="col">#</th>
            <th scope="col"> Week Start Date  </th>
            <th scope="col"> Week End Date  </th>
            <th scope="col"> status  </th>
            <th scope="col"> Diary Submitted Date  </th>
            <th scope="col"> Diary Approval Date  </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let fyWeek of financialYearsWeekList; index as i" id="branch_{{i+1}}">
            <td scope="row">
              <input type="radio" [(ngModel)]="radioSelected" name="list_name" value="{{i}}" (change)="onWeekChange(fyWeek)"/>
            </td>
            <td>{{fyWeek.weekStartDate | date: 'dd-MMM-yyyy'}}</td>
            <td>{{fyWeek.weekEndDate | date: 'dd-MMM-yyyy'}}</td>
            <td>{{fyWeek.status}}</td>
            <td>{{fyWeek.diarySubmittedDate | date: 'dd-MMM-yyyy'}}</td>
            <td>{{fyWeek.diaryApprovalDate | date: 'dd-MMM-yyyy'}}</td>
          </tr>
        </tbody>
      </table>
      <!-- <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [maxSize]="1" size="sm" [pageSize]="pageSize" (pageChange)="refreshCollectionList()">
      </ngb-pagination> -->
    </div>
  </div>
</div>
</div>
</div>
